import '../GerenciamentoTurmas/GerenciamentoTurmas.css';
import React, { useState, useEffect } from 'react';
import { FormGroup, Table, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { JournalBookmark, DashCircleFill } from 'react-bootstrap-icons';
import axios from 'axios';


const GerenciamentoMotoristas = (props) => {
    const [listaMotoristas, setListaMotoristas] = useState(JSON.parse(localStorage.getItem('listaMotoristas')));
    const [listaIntegrantesBackup, setListaIntegrantesBackup] = useState(JSON.parse(localStorage.getItem('listaMotoristas')));
    const [edicaoMotoristaModal, setEdicaoMotoristaModal] = useState(false);
    const username = process.env.REACT_APP_ANJO_BACKEND_USER
    const password = process.env.REACT_APP_ANJO_BACKEND_PSW

    useEffect(() => {
        fillMotoristaList();
    }, []);

    const toggleEdicaoMotoristaModal = () => {
        setEdicaoMotoristaModal(!edicaoMotoristaModal);
    }

    const fillMotoristaList = async () => {
        const response = await axios.get("motorista/getTodosPorUnidade/" + props.token.usuario.departamento.id.codfilial, {
            auth: {
                username,
                password
            }
        })
        localStorage.setItem('listaMotoristas', JSON.stringify(response.data));
        setListaMotoristas(response.data);
    }

    const deleteMotorista = async (motorista) => {
        let cpfSelecionado = motorista.cpf;
        const response = await axios.delete("motorista/delete/" + cpfSelecionado, {
            auth: {
                username,
                password
            }
        })
        fillMotoristaList();
    }
    const renderlistaIntegrantes = () => {
        let renderedList = [];
        for (let Integrante of listaMotoristas) {
            renderedList.push(renderIntegranteSingle(Integrante));
        }
        return renderedList;
    }

    const filterList = (valorReferencia) => {
        setListaMotoristas(listaIntegrantesBackup);
        if (valorReferencia) {
            let listaIntegrantesMod = listaIntegrantesBackup.filter(integrante => substringComparator(
                integrante.nome.toUpperCase().replaceAll(' ', ''), valorReferencia.trim().toUpperCase()));
            setListaMotoristas(listaIntegrantesMod);
        }
    }

    const substringComparator = (valorBase, valorReferencia) => {
        let splitReferencia = valorReferencia.split(' ');
        let values = 0;
        for (let substring of splitReferencia) {
            if (valorBase.includes(substring)) {
                values++;
            }
        };
        return values === splitReferencia.length;
    }

    const renderIntegranteSingle = (integrante) => {
        return (
            <div className="tabelaItem" >
                <div className="tabelaComponent" >
                    {integrante.nome}
                </div>
                <DashCircleFill size={25} className="tabelaComponent" onClick={() => deleteMotorista(integrante)}/>
            </div>
        );
    }

    return (
        <>
            <h2 className="titulosPaginas">Motoristas</h2>
            <input type="text" placeholder="Buscar por Nome" className="pesquisaRapidaTurmas"
                onChange={(e) => filterList(e.target.value)} />
            <FormGroup>
                <div className="TabelaConfig">
                    <div className="TabelaGer">
                        <div className="tabelaItem">
                            <h6 className="titulosTabelas">
                                NOME MOTORISTA
                            </h6>
                            <h6 className="titulosTabelas">
                                OPÇÕES
                            </h6>
                        </div>
                    </div>
                    {listaMotoristas === null ? (<tr> <td> none </td></tr>) : (renderlistaIntegrantes())}
                </div>
            </FormGroup>
            <Modal isOpen={edicaoMotoristaModal} toggle={toggleEdicaoMotoristaModal}>
                <ModalHeader className="TabelaGer" toggle={toggleEdicaoMotoristaModal}>
                    <h4>Edição Motorista</h4>
                </ModalHeader>
                <ModalBody className="modalConfig">
                </ModalBody>
            </Modal>
        </>
    );
}

export default GerenciamentoMotoristas;